import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { useTheme } from "styled-components";
import Svg from "../Svg";
var Icon = function(props) {
    var theme = useTheme();
    var primaryColor = theme.isDark ? " rgba(236, 228, 253, 0.1)" : "#0B3D91";
    var secondaryColor = theme.isDark ? " rgba(164, 175, 193, 1)" : "white";
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        width: "41",
        height: "40",
        viewBox: "0 0 41 40",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ _jsxs("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ _jsx("rect", {
                    width: "40",
                    height: "40",
                    rx: "20",
                    fill: primaryColor
                }),
                /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M19.9951 7C16.7455 7.00169 13.6025 8.15263 11.128 10.247C8.65349 12.3414 7.00894 15.2427 6.48836 18.4321C5.96779 21.6215 6.60515 24.8911 8.28649 27.6561C9.96782 30.4211 12.5835 32.5013 15.6658 33.5248C16.3458 33.651 16.6019 33.2295 16.6019 32.8712C16.6019 32.5128 16.5883 31.4738 16.5838 30.3379C12.7758 31.1606 11.9711 28.731 11.9711 28.731C11.35 27.1533 10.4524 26.7386 10.4524 26.7386C9.21028 25.8957 10.5454 25.9115 10.5454 25.9115C11.9212 26.0084 12.6443 27.3156 12.6443 27.3156C13.8638 29.3958 15.8471 28.7941 16.6268 28.4425C16.7492 27.5613 17.1051 26.9618 17.4973 26.6214C14.4554 26.2789 11.2594 25.1114 11.2594 19.8961C11.2405 18.5436 11.7453 17.2356 12.6692 16.2428C12.5287 15.9002 12.0595 14.5164 12.803 12.6367C12.803 12.6367 13.9522 12.2716 16.5679 14.0318C18.8115 13.4217 21.1787 13.4217 23.4223 14.0318C26.0358 12.2716 27.1828 12.6367 27.1828 12.6367C27.9285 14.5119 27.4593 15.8957 27.3188 16.2428C28.2456 17.2358 28.7515 18.546 28.7309 19.9007C28.7309 25.1272 25.5281 26.2789 22.4817 26.6147C22.9713 27.0384 23.4087 27.8655 23.4087 29.1367C23.4087 30.9577 23.3929 32.4227 23.3929 32.8712C23.3929 33.234 23.6399 33.6577 24.3335 33.5248C27.4162 32.5012 30.0321 30.4206 31.7134 27.6551C33.3947 24.8896 34.0317 21.6196 33.5106 18.4299C32.9894 15.2402 31.344 12.3389 28.8687 10.2449C26.3934 8.15081 23.2497 7.00062 19.9997 7H19.9951Z",
                    fill: secondaryColor
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M11.49 26.543C11.4605 26.6106 11.3517 26.6309 11.2633 26.5836C11.1749 26.5362 11.1092 26.4483 11.1409 26.3785C11.1727 26.3086 11.2792 26.2906 11.3676 26.3379C11.456 26.3852 11.524 26.4754 11.49 26.543Z",
                    fill: secondaryColor
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M12.0455 27.1582C11.9985 27.1817 11.9448 27.1883 11.8936 27.1768C11.8423 27.1652 11.7966 27.1364 11.7644 27.0951C11.676 27.0004 11.6579 26.8697 11.7259 26.8111C11.7939 26.7525 11.9163 26.7796 12.0047 26.8742C12.0931 26.9689 12.1135 27.0996 12.0455 27.1582Z",
                    fill: secondaryColor
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M12.5853 27.9394C12.5015 27.998 12.3587 27.9394 12.2793 27.8222C12.2574 27.8012 12.2399 27.776 12.228 27.7481C12.2161 27.7202 12.21 27.6902 12.21 27.6599C12.21 27.6296 12.2161 27.5996 12.228 27.5718C12.2399 27.5439 12.2574 27.5187 12.2793 27.4976C12.3632 27.4413 12.506 27.4976 12.5853 27.6126C12.6647 27.7275 12.6669 27.8808 12.5853 27.9394Z",
                    fill: secondaryColor
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M13.317 28.6975C13.2422 28.7809 13.0904 28.7584 12.9657 28.6457C12.841 28.533 12.8116 28.3797 12.8864 28.2986C12.9612 28.2175 13.113 28.24 13.2422 28.3505C13.3714 28.4609 13.3964 28.6164 13.317 28.6975Z",
                    fill: secondaryColor
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M14.3435 29.1386C14.3095 29.2445 14.1554 29.2919 14.0013 29.2468C13.8471 29.2017 13.7451 29.0755 13.7746 28.9673C13.8041 28.8591 13.9605 28.8095 14.1169 28.8591C14.2733 28.9087 14.373 29.0282 14.3435 29.1386Z",
                    fill: secondaryColor
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M15.464 29.216C15.464 29.3264 15.3371 29.421 15.1739 29.4233C15.0107 29.4256 14.877 29.3354 14.877 29.225C14.877 29.1145 15.0039 29.0199 15.1671 29.0176C15.3303 29.0154 15.464 29.1033 15.464 29.216Z",
                    fill: secondaryColor
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M16.5067 29.0423C16.5271 29.1527 16.4138 29.2677 16.2506 29.2947C16.0874 29.3218 15.9446 29.2564 15.9242 29.1482C15.9038 29.0401 16.0216 28.9229 16.1803 28.8936C16.339 28.8643 16.4863 28.9319 16.5067 29.0423Z",
                    fill: secondaryColor
                })
            ]
        })
    }));
};
export default Icon;
